import React from 'react'
import { Button, Card, CardBody, CardHeader, Col, Container, Form, FormGroup, Label, Row, Collapse, Input, Table } from 'reactstrap';

export const ComponentUnit = ({analyteCurves,key}) => {
  return (
    <div key={key}>
        {
            <label className=''>{analyteCurves.unit}</label>
        }

    </div>
  )
}
